<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive code="declarations1" v-model="sasSociete.declaration1" :live="liveSociete(25919)" />
    <CaseACocherLive code="declarations2" v-model="sasSociete.declaration2" :live="liveSociete(25920)" />
    <CaseACocherLive code="declarations3" v-model="sasSociete.declaration3" :live="liveSociete(25921)" :opqIf="conditionDeclaration3" />
    <CaseACocherLive code="declarations4" v-model="sasSociete.declaration4" :live="liveSociete(25922)" />
    <CaseACocherLive code="declarations5" v-model="sasSociete.declaration5" :live="liveSociete(25923)" />

  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionDeclaration3() {
      return (
        this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SPA"
      )
    },
  },
  methods: {
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    }
  }
}
</script>

<style></style>
